var _circle, _circle2, _circle3, _circle4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTestImg1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 801,
    height: 801,
    viewBox: "0 0 801 801",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 400,
    cy: 400,
    r: 290,
    fill: "#ffffff",
    fillOpacity: 0.03
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 400,
    cy: 400,
    r: 230,
    fill: "#ffffff",
    fillOpacity: 0.05
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 400,
    cy: 400,
    r: 170,
    fill: "#ffffff",
    fillOpacity: 0.2
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 400,
    cy: 400,
    r: 110,
    fill: "#ffffff",
    fillOpacity: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTestImg1);
export default __webpack_public_path__ + "static/media/test_img_1.59053a612a83e2f8bdad13506ac7f297.svg";
export { ForwardRef as ReactComponent };